import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { routes } from './routes'

// Create the browser router instance
const router = createBrowserRouter(routes)

/**
 * Router component that provides routing context to the app
 */
export function AppRouter() {
  return <RouterProvider router={router} />
}

// Re-export route guards for use in other components
export { ProtectedRoute } from './ProtectedRoute'
export { AuthRoute } from './AuthRoute'
export { ForcePasswordRoute } from './ForcePasswordRoute'
export { PermissionRoute } from './PermissionRoute'
